import { StepResolutionArgs, StepResolutionProvider } from '@/plugin-system/runtime/time/resolution';
import { VizFrameworkConfigArgs, VizFrameworkConfigProvider } from '../model/config';
import { GlobalFiltersArgs, GlobalFiltersProvider } from '../runtime/GlobalFilters';

export type VizFrameworkProviderProps = {
  children: React.ReactNode;
  config?: VizFrameworkConfigArgs;
  globalFiltersConfig?: GlobalFiltersArgs;
  stepResolutionConfig?: StepResolutionArgs;
};

// TODO: This will eventually be the single provider that will be composed of all core runtime providers
export function VizFrameworkProvider(props: VizFrameworkProviderProps) {
  return (
    <VizFrameworkConfigProvider {...props.config}>
      <StepResolutionProvider {...props.stepResolutionConfig}>
        <GlobalFiltersProvider {...props.globalFiltersConfig}>{props.children}</GlobalFiltersProvider>
      </StepResolutionProvider>
    </VizFrameworkConfigProvider>
  );
}
